import { RLCard } from "../../../../../../components";
import { StoryParagraphs } from "../../../../@types/sample_details";
import { COMPONENT_IDS } from "../../../../consts";
import {
  useGetReportSummary,
  useLocalSampleSummaryParams
} from "../../../../hooks";
import { DESCRIPTIONS } from "../../../layout-editor/consts";
import { PDFExport } from "../../@types/PDFExport";
import { useMediaAddressParagraph } from "../../hooks";
import usePivotMap from "../../hooks/usePivotMap";
import { Tooltip } from "../common";
import { Story } from "./components";

type Props = PDFExport;

const SampleDescriptionCard = ({ isPdfView }: Props) => {
  const { hash, sourceId, relationshipId } = useLocalSampleSummaryParams();
  const { data } = useGetReportSummary(hash, sourceId, relationshipId);
  const { pivotMap } = usePivotMap(hash, sourceId, relationshipId);
  const { additionalParagraphs } = useMediaAddressParagraph();

  const changePivotInStory = (
    story?: StoryParagraphs
  ): StoryParagraphs | undefined =>
    story?.map(part => ({
      ...part,
      arguments: part.arguments.map(arg => pivotMap?.[arg.text] || arg)
    }));

  return (
    <RLCard
      header={
        <RLCard.Header>
          <Tooltip
            message={DESCRIPTIONS[COMPONENT_IDS.SAMPLE_DESCRIPTION]}
            placement="top"
          >
            <span>Sample Description</span>
          </Tooltip>
        </RLCard.Header>
      }
      content={
        <RLCard.Content>
          <Story
            story={changePivotInStory(data?.story)}
            isPdfView={isPdfView}
            additionalParagraphs={additionalParagraphs}
          />
        </RLCard.Content>
      }
      data-testid="report_summary_sample_description_card"
    />
  );
};

export default SampleDescriptionCard;
